// ============================================================
//  AppContext.jsx  – global loader + toast state
// ============================================================
import React, { createContext, useContext, useState, useCallback, useRef } from "react";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [toasts, setToasts] = useState([]);
    const counterRef = useRef(0);

    const showToast = useCallback((type, message, duration = 4000) => {
        const id = ++counterRef.current;
        setToasts(prev => [...prev, { id, type, message }]);
        setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
    }, []);

    const dismissToast = useCallback((id) => {
        setToasts(prev => prev.filter(t => t.id !== id));
    }, []);

    return (
        <AppContext.Provider value={{ loading, setLoading, showToast }}>
            {children}

            {/* Global Loader */}
            {loading && (
                <div className="loader-overlay">
                    <div className="loader-spinner" />
                </div>
            )}

            {/* Global Toasts */}
            <div className="mx-toast">
                {toasts.map(t => (
                    <div key={t.id} className={`mx-toast-item mx-toast-item--${t.type}`}>
                        <span style={{ flex: 1 }}>{t.message}</span>
                        <button
                            onClick={() => dismissToast(t.id)}
                            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 16, lineHeight: 1, color: "inherit", padding: "0 0 0 8px" }}
                        >×</button>
                    </div>
                ))}
            </div>
        </AppContext.Provider>
    );
};

export const useApp = () => {
    const ctx = useContext(AppContext);
    if (!ctx) throw new Error("useApp must be used inside AppProvider");
    return ctx;
};
